import { mapState, mapGetters } from 'vuex';

const getApiHotels = {
  data() {
    return {
      hotels: [],
    };
  },
  computed: {
    apiLocale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en-us';
        case 'es':
          return 'es-es';
        default:
          return 'pt-br';
      }
    },
    ...mapState(['apiData']),
    ...mapGetters(['settings']),
  },
  methods: {
    setHotels({ getSorted, customBehavior, endpoint }) {
      let hotels = [...this.apiData[endpoint]];
      if (getSorted) {
        hotels = hotels.sort((hotelA, hotelB) => {
          return hotelA.Nome.trim().localeCompare(hotelB.Nome.trim());
        });
      }

      hotels = hotels.filter((hotel) => hotel && hotel.Ativo);

      this.hotels =
        typeof customBehavior === 'function' ? customBehavior(hotels) : hotels;
    },
    async getApiHotels({
      getSorted = true,
      customBehavior,
      customEndpoint,
    } = {}) {
      const endpoint =
        customEndpoint ||
        `${this.settings.letsbookApiId}/hoteisLanding/${this.settings.letsbookLandingPageId}/${this.apiLocale}`;

      if (!this.apiData[endpoint]) {
        try {
          await this.$store.dispatch('loadApiData', endpoint);
        } catch {
          return;
        }
      }

      this.setHotels({
        getSorted,
        customBehavior,
        endpoint,
      });
    },
  },
};

export default getApiHotels;
